import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { tpoGenUrls } from 'config/urls';
import { sendNotification } from 'utils/helperMethods';
import { isEditLockError, useEditWriteGuard } from '../../../EditSession/useEditWriteGuard';

export interface RunOptimizationResponse {
    job_id: string;
}

const runOptimizationRequest = async (payload: Record<string, unknown>): Promise<RunOptimizationResponse> => {
    const response = await axios(tpoGenUrls.runOptimisation, {
        method: 'POST',
        data: payload,
    });
    return response.data;
};

const useRunOptimizationMutation = () => {
    const assertCanWrite = useEditWriteGuard();

    const { mutate, isPending } = useMutation({
        mutationFn: (payload: Record<string, unknown>) => {
            assertCanWrite();
            return runOptimizationRequest(payload);
        },
        onError: (error: unknown) => {
            if (isEditLockError(error)) {
                sendNotification('error', error.message, 5, 450);
                return;
            }
            const detail = (error as { response?: { data?: { detail?: string } } })?.response?.data?.detail;
            sendNotification('error', detail ?? 'Something went wrong');
        },
    });

    return { mutate, isPending };
};

export default useRunOptimizationMutation;
